import React from 'react'

class Items extends React.Component {
    dateSlice = d => {
        if (d === '마감') return d
        let dt = d.split(' ')
        dt = dt[0].split('-')
        return `${dt[0]}.${dt[1]}.${dt[2]}`
    }

    cmtEdDate = dt => {
        let d = dt
        if (d === '마감') return d
        const tod = new Date()
        d = d.split(' ')
        const t = d[1].split(':')
        d = d[0].split('-')
        const edd = new Date(d[0], d[1] - 1, d[2], t[0], t[1], t[2])
        let diff = (edd.getTime() - tod.getTime()) / (1000 * 60 * 60 * 24)
        diff = parseInt(diff, 10)
        if (diff > 1) diff = `D-${diff}`
        if (diff === 0) diff = 'D-day'
        if (diff < 1) diff = '마감'
        return diff
    }

    render() {
        const iv = this.props.value // Item Value
        const isWin =
            iv.my_evt_proc === 2 ? (
                <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_event_is_win2.png`} alt="당첨" />
            ) : (
                <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_event_is_win3.png`} alt="낙첨" />
            )
        const winDay = iv.dt_win ? iv.dt_win : iv.dt_ed
        const cmtDay = iv.dt_ed_win_cmt ? iv.dt_ed_win_cmt : '마감'
        return (
            <tr>
                <td>{iv.no}</td>
                <td className="win">
                    <a href={`/win/detail/${iv.idx_cat_evt}`} title={`${iv.nm_evt} 당첨자 발표`}>
                        {iv.nm_evt}
                    </a>
                </td>
                <td>{`${this.dateSlice(iv.dt_st)} ~ ${this.dateSlice(iv.dt_ed)}`}</td>
                <td>{this.dateSlice(winDay)}</td>
                {this.props.isMy && <td className="iswin">{isWin}</td>}
                <td>{this.cmtEdDate(cmtDay)}</td>
            </tr>
        )
    }
}
export default Items
